// @ts-nocheck
import axios from "axios";
import { EnvKeys } from "constants/EnvKeys";

export const ImpairmentHttp = axios.create({
  baseURL: EnvKeys.API_IMPAIRMENT_URL,
});

export const FineractHttp = axios.create({
  baseURL: EnvKeys.API_URL,
  headers: {
    "Fineract-Platform-TenantId": "default",
  },
});

export const FineractEDRHttp = axios.create({
  baseURL: EnvKeys.EDR_API_BASEURL,
  headers: {
    "Fineract-Platform-TenantId": "default",
  },
});

export const SequestHttp = axios.create({
  baseURL: EnvKeys.CDL_SEQUEST_API_URL,
});

export const PublicHttp = axios.create({
  baseURL: EnvKeys.API_URL,
  headers: {
    Authorization: `${EnvKeys.FINERACT_PUBLIC_API_SCHEME} ${EnvKeys.FINERACT_PUBLIC_API_KEY}`, // commenting this out because uncommenting it causes links like http://localhost:3000/_/credit-direct-pay/<id> to fail on production
    "Fineract-Platform-TenantId": "default",
  },
});

export const FineractExternalHttp = axios.create({
  baseURL: EnvKeys.FINERACT_EXTERNAL_API_URL,
  headers: {
    Authorization: `Bearer ${EnvKeys.FINERACT_EXTERNAL_API_KEY}`,
  },
});

export const HookHttp = axios.create({
  baseURL: EnvKeys.NX360_HOOK_API_URL,
});

export const NeduWrapperHttp = axios.create({
  baseURL: EnvKeys.NEDU_WRAPPER_API,
});

export const nipSupportHttp = axios.create({
  baseURL: EnvKeys.REACT_APP_NIP_SUPPORT_API_URL,
  headers: {
    "auth-key": EnvKeys.REACT_APP_NIP_SUPPORT_API_KEY,
  },
});

export const paySyncHttp = axios.create({
  baseURL: EnvKeys.REACT_APP_PAY_SYNC_API_URL,
  headers: {
    Authorization: EnvKeys.REACT_APP_PAY_SYNC_API_KEY,
  },
});

export const zeusHttp = axios.create({
  baseURL: EnvKeys.REACT_APP_ZEUS_BASE_URI_API,
  headers: {
    Authorization: EnvKeys.REACT_APP_ZEUS_BASE_URI_API_KEY,
  },
});

export const outwardTransactionHttp = axios.create({
  baseURL: EnvKeys.REACT_APP_OUTWARD_TRANSACTION_API_URL,
  headers: {
    // "auth-key": EnvKeys.REACT_APP_NIP_SUPPORT_API_KEY,
  },
});

export default FineractHttp;
